export default "__VITE_ASSET__CTUQErc5__"